import config from '../config';
import { getGameName } from '../service/lobby';
import { getUserPublicProfile } from '../service/social';
import { validate as isValidUUID } from 'uuid';

export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_CONFIG_APIKEY,
    authDomain: process.env.REACT_APP_FIREBASE_CONFIG_AUTHDOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECTID,
    storageBucket: process.env.REACT_APP_FIREBASE_CONFIG_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_CONFIG_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_FIREBASE_CONFIG_APPID,
    measurementId: process.env.REACT_APP_FIREBASE_CONFIG_MEASUREMENTID,
};

export const getNotificationDisplayData = async (
    userID: string,
    licenseID: string,
): Promise<{ title: string; body: string; icon: string; data: {} }> => {
    const gameName = getGameName(licenseID);

    const userProfile = await getUserPublicProfile(userID);

    const username =
        userProfile?.username && !isValidUUID(userProfile.username)
            ? userProfile.username
            : userProfile?.twitch_profile?.display_name;

    const pp =
        userProfile?.avatar_object_url ||
        userProfile?.twitch_profile?.profile_image_url ||
        config.avatarPlaceholderURL;

    const title = `${username || gameName} is LIVE!`;
    const body = username ? `Playing ${gameName || 'a SIX'}` : '';
    const icon = pp;
    const data = {
        onClickURL: `/user/${userID}`,
    };
    return { title, body, icon, data };
};
